import { atom } from "jotai";
import getWindowAtom from "app/uiState/getWindowAtom";
import { activeWindowHistoryAtom } from "./activeWindowHistoryAtom";
import getWindowActivityAtom from "./getWindowActivityAtom";

let zIndex = 1;

const activeWindowAtomPrimitive = atom<string | null>(null);

const activeWindowAtom = atom(
  (get) => get(activeWindowAtomPrimitive),
  (get, set, id: string | null) => {
    const current = get(activeWindowAtomPrimitive);

    if (current === id) return;

    if (current !== null) {
      set(getWindowActivityAtom(current), {
        active: false,
        inactiveSince: Date.now(),
      });
    }

    if (id === null) {
      set(activeWindowAtomPrimitive, null);
      return;
    }

    set(getWindowAtom(id), (state) => {
      if (!state) return state;
      return {
        ...state,
        uiProps: {
          ...state.uiProps,
          zIndex: zIndex++,
          minimised: false,
        },
      };
    });

    // Update activation history (only for real IDs)
    const history = get(activeWindowHistoryAtom).filter((x) => x !== id);
    history.push(id);
    set(activeWindowHistoryAtom, history);

    // Set active window id
    set(activeWindowAtomPrimitive, id);
    set(getWindowActivityAtom(id), (activity) => ({
      ...activity,
      active: true,
    }));
  },
);

export default activeWindowAtom;
